function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      fill: "#DA5B65"
    },
    d: "M469.04,72.154H42.959C19.23,72.154,0,91.384,0,115.102v62.469l256,32.033l256-32.033v-62.469 C512,91.384,492.77,72.154,469.04,72.154z"
  }), React.createElement("path", {
    style: {
      fill: "#D4D2D3"
    },
    d: "M512,177.571v262.736c0,23.718-19.23,42.948-42.96,42.948H42.959C19.23,483.256,0,464.026,0,440.308 V177.571H512z"
  }), React.createElement("path", {
    style: {
      fill: "#BAB8B9"
    },
    d: "M452.98,212.89H59.02c-13.069,0-23.701,10.632-23.701,23.701v38.919c0,0.001,0,0.003,0,0.004 s0,0.002,0,0.004v54.884c0,0.003,0,0.006,0,0.01s0,0.006,0,0.01v54.873c0,0.005-0.001,0.01-0.001,0.015s0.001,0.01,0.001,0.016 v38.909c0,13.069,10.632,23.7,23.701,23.7h393.959c13.069,0,23.701-10.633,23.701-23.7V236.591 C476.681,223.522,466.049,212.89,452.98,212.89z M400.384,322.688h-45.392v-39.446h45.392V322.688z M415.837,283.241h45.392v39.446 h-45.392V283.241z M217.851,322.688H172.46v-39.446h45.392V322.688z M233.304,283.241h45.392v39.446h-45.392L233.304,283.241z  M217.851,338.14v39.446H172.46V338.14H217.851z M233.304,338.14h45.392v39.446h-45.392L233.304,338.14z M294.149,338.14h45.392 v39.446h-45.392V338.14z M294.149,322.688v-39.446h45.392v39.446H294.149z M354.992,267.788v-39.447h45.392v39.447H354.992z  M339.539,267.788h-45.392v-39.447h45.392V267.788z M278.695,267.788h-45.392v-39.447h45.392V267.788z M217.851,267.788H172.46 v-39.447h45.392V267.788z M157.007,267.788h-45.392v-39.447h45.392V267.788z M157.008,283.241v39.446h-45.392v-39.446H157.008z  M96.163,322.688H50.772v-39.446h45.392L96.163,322.688z M50.772,338.14h45.392v39.446H50.772V338.14z M111.616,338.14h45.392 v39.446h-45.392L111.616,338.14z M157.008,393.039v39.447h-45.392v-39.447H157.008z M172.461,393.039h45.392v39.447h-45.392V393.039 z M233.305,393.039h45.392v39.447h-45.392V393.039z M294.149,393.039h45.392v39.447h-45.392V393.039z M354.993,393.039h45.392 v39.447h-45.392V393.039z M354.992,377.586V338.14h45.392v39.446H354.992z M415.837,338.14h45.392v39.446h-45.392V338.14z  M461.229,236.591v31.198h-45.392v-39.447h37.144C457.528,228.343,461.229,232.043,461.229,236.591z M59.02,228.343h37.143v39.447 H50.771v-31.198C50.771,232.043,54.472,228.343,59.02,228.343z M50.772,424.237v-31.198h45.392v39.447H59.021 C54.473,432.484,50.772,428.785,50.772,424.237z M452.98,432.484h-37.143v-39.447h45.392v31.198 C461.229,428.785,457.528,432.484,452.98,432.484z"
  }), React.createElement("path", {
    style: {
      fill: "#C0344A"
    },
    d: "M42.96,72.154c-5.025,0-9.843,0.871-14.326,2.455v22.35c0,24.459,19.898,44.357,44.357,44.357 s44.358-19.898,44.358-44.357V72.154H42.96z"
  }), React.createElement("path", {
    style: {
      fill: "#BAB8B9"
    },
    d: "M72.99,28.744L72.99,28.744c-10.274,0-18.602,8.328-18.602,18.602V96.96 c0,10.274,8.328,18.602,18.602,18.602l0,0c10.274,0,18.602-8.328,18.602-18.602V47.346C91.592,37.072,83.264,28.744,72.99,28.744z"
  }), React.createElement("path", {
    style: {
      fill: "#C0344A"
    },
    d: "M150.64,72.154V96.96c0,24.459,19.898,44.356,44.358,44.356c24.458,0,44.357-19.898,44.357-44.357 V72.154H150.64z"
  }), React.createElement("path", {
    style: {
      fill: "#BAB8B9"
    },
    d: "M194.997,28.744L194.997,28.744c-10.274,0-18.602,8.328-18.602,18.602V96.96 c0,10.274,8.328,18.602,18.602,18.602l0,0c10.274,0,18.602-8.328,18.602-18.602V47.346 C213.599,37.072,205.271,28.744,194.997,28.744z"
  }), React.createElement("path", {
    style: {
      fill: "#C0344A"
    },
    d: "M317.003,141.316c24.459,0,44.358-19.898,44.358-44.357V72.154h-88.713V96.96 C272.647,121.417,292.546,141.316,317.003,141.316z"
  }), React.createElement("path", {
    style: {
      fill: "#BAB8B9"
    },
    d: "M317.003,28.744L317.003,28.744c-10.274,0-18.602,8.328-18.602,18.602V96.96 c0,10.274,8.328,18.602,18.602,18.602l0,0c10.274,0,18.602-8.328,18.602-18.602V47.346 C335.605,37.072,327.277,28.744,317.003,28.744z"
  }), React.createElement("path", {
    style: {
      fill: "#C0344A"
    },
    d: "M439.01,141.316c24.458,0,44.357-19.898,44.357-44.357V74.609c-4.481-1.585-9.301-2.455-14.326-2.455 h-74.388V96.96C394.653,121.417,414.551,141.316,439.01,141.316z"
  }), React.createElement("path", {
    style: {
      fill: "#BAB8B9"
    },
    d: "M439.01,28.744L439.01,28.744c-10.274,0-18.602,8.328-18.602,18.602V96.96 c0,10.274,8.328,18.602,18.602,18.602l0,0c10.274,0,18.602-8.328,18.602-18.602V47.346C457.612,37.072,449.284,28.744,439.01,28.744 z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.d2b4ddeb.svg";
export { ForwardRef as ReactComponent };